import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=fb400d16&"
import script from "./Policies.vue?vue&type=script&lang=ts&"
export * from "./Policies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Policies.vue"
export default component.exports